var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZoomIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    width: 32,
    height: 32,
    rx: 8,
    fill: "#14142A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4671 16.2998H14.1338C13.8605 16.2998 13.6338 16.0731 13.6338 15.7998C13.6338 15.5265 13.8605 15.2998 14.1338 15.2998H17.4671C17.7405 15.2998 17.9671 15.5265 17.9671 15.7998C17.9671 16.0731 17.7405 16.2998 17.4671 16.2998Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7998 17.9666C15.5265 17.9666 15.2998 17.74 15.2998 17.4666V14.1333C15.2998 13.86 15.5265 13.6333 15.7998 13.6333C16.0731 13.6333 16.2998 13.86 16.2998 14.1333V17.4666C16.2998 17.74 16.0731 17.9666 15.7998 17.9666Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6663 22.5002C11.8997 22.5002 8.83301 19.4335 8.83301 15.6668C8.83301 11.9002 11.8997 8.8335 15.6663 8.8335C19.433 8.8335 22.4997 11.9002 22.4997 15.6668C22.4997 19.4335 19.433 22.5002 15.6663 22.5002ZM15.6663 9.8335C12.4463 9.8335 9.83301 12.4535 9.83301 15.6668C9.83301 18.8802 12.4463 21.5002 15.6663 21.5002C18.8863 21.5002 21.4997 18.8802 21.4997 15.6668C21.4997 12.4535 18.8863 9.8335 15.6663 9.8335Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6666 23.1666C22.54 23.1666 22.4133 23.12 22.3133 23.02L20.98 21.6866C20.7866 21.4933 20.7866 21.1733 20.98 20.98C21.1733 20.7866 21.4933 20.7866 21.6866 20.98L23.02 22.3133C23.2133 22.5066 23.2133 22.8266 23.02 23.02C22.92 23.12 22.7933 23.1666 22.6666 23.1666Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomIn);
export default __webpack_public_path__ + "static/media/zoom-in.256b53ad1beec4bd8a3f216938903e4a.svg";
export { ForwardRef as ReactComponent };